/* tslint:disable */
/**
* Auto generated version file, do not modify it!
*/
const version = '1.12.14';
export { version };
//# sourceMappingURL=version.js.map